export default "__VITE_ASSET__DALftwDZ__"